import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {ReportTableComponent} from "src/app/features/dashboard/components/report-table/report-table.component";
import {
  PAGE_SIZE,
  TABLE_CONFIG,
  TableConfig,
  TableType
} from "../../../dashboard/components/report-table/table-config";
import {PaginatorComponent} from "../../../../shared/components/paginator/paginator.component";

export interface PageChangeEvent {
  page: number,
  tableType: TableType
}

export type TableTypes = 'activeReports' | 'reports' | 'escalatedReports';

@Component({
  selector: "app-workplace-card",
  standalone: true,
  imports: [CommonModule, RouterModule, ReportTableComponent, PaginatorComponent],
  template: `
    <div class="card mx-1 me-1 p-1">
      <div *ngIf="workplace.name" class="heading py-2 mt-3 mx-2 d-flex justify-content-between">
        {{ workplace.name }}
        <i class="bi bi-chevron-right"></i>
      </div>
      <div class="card-body">
        <div
          *ngIf="hasAnyReports(); else noReports
          "
        >
          <ng-container *ngFor="let prop of displayProperties; let i = index">
            <div *ngIf="hasData(prop)"
                 [ngClass]="{ 'mt-5': i > 0 && hasData(prop) }"
            >
              <app-report-table
                *ngIf="hasData(prop)"
                [dataSource]="workplace[prop]"
                [displayAll]="this.displayAllEntries"
                [tableHeading]="getTableConfig(prop).heading"
                [displayedColumns]="getTableConfig(prop).displayedColumns"
                [columnWidths]="getTableConfig(prop).columnWidths"
                [tableWidth]="tableWidth"
              ></app-report-table>
              <app-paginator
                *ngIf="this.pagination"
                [totalPages]="this.totalPages[getTableConfig(prop).tableType]"
                (pageChange)="onPageChange({page: $event, tableType: getTableConfig(prop).tableType})"
              ></app-paginator>
            </div>
          </ng-container>
        </div>
        <ng-template #noReports>
          <p>Keine Stillstandmeldungen gefunden</p>
        </ng-template>
      </div>
    </div>
  `,
  styles: [],
})
export class WorkplaceCardComponent {
  @Input() workplace: any = {};
  @Input() displayProperties: TableTypes[] = ['activeReports', 'reports', 'escalatedReports'];
  @Input() displayAllEntries: boolean = false;
  @Input() totalPages: { activeReports: number, solvedReports: number, escalatedReports: number } = {
    activeReports: 1,
    solvedReports: 1,
    escalatedReports: 1
  }
  @Input() pagination: boolean = false;
  @Input() tableWidth: 'w-50' | 'w-75' | 'w-100' = 'w-75'
  @Output() emitPageChange = new EventEmitter<PageChangeEvent>()

  getTableConfig(property: string): TableConfig {
    return TABLE_CONFIG[property]
  }

  hasData(property: string): boolean {
    return this.workplace[property]?.length > 0;
  }

  hasAnyReports(): boolean {
    return this.displayProperties.some(prop => this.hasData(prop))
  }

  onPageChange(pageChangeEvent: PageChangeEvent): void {
    this.emitPageChange.emit({page: pageChangeEvent.page, tableType: pageChangeEvent.tableType})
  }

  protected readonly Math = Math;
  protected readonly PAGE_SIZE = PAGE_SIZE;
}
